import { useState } from 'react'

import { DsIcon as Icon } from '@itau-loans-www/components'
import { http, sdkAnalytics } from '@itau-loans-www/services'
import { isClient, getDevice } from '@itau-loans-www/utils'
import platform from 'platform'

export const useBlockedBenefit = () => {
  const [isAlertVisible, setIsAlertVisible] = useState(true)
  const [isFinished, setIsFinished] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { os } = platform

  const carouselConfig = {
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <Icon id="right-arrow" name="seta-direita" type="outlined" />,
    prevArrow: <Icon id="left-arrow" name="seta-esquerda" type="outlined" />
  }

  const closeAlert = () => setIsAlertVisible(false)

  const getLink = () => {
    const isMobile = getDevice.isMobile()
    const link = {
      desktop: 'https://meu.inss.gov.br/#/login',
      Android:
        'https://play.google.com/store/apps/details?id=br.gov.dataprev.meuinss',
      iOS: 'https://apps.apple.com/us/app/meu-inss-central-de-servi%C3%A7os/id1243048358'
    }

    if (!isMobile) return link.desktop

    return link[os.family]
  }

  const handleInssBtn = () => {
    if (isClient()) {
      const link = getLink()
      sdkAnalytics.track('trackClick', 'btn:preciso-de-ajuda')
      window.open(link, '_blank')
    }
  }

  const handleHelpBtn = async () => {
    try {
      setIsLoading(true)
      sdkAnalytics.track('trackClick', 'btn:acessar-app-meu-inss')

      if (!isFinished) {
        await http.proposal.finishSimulationOnWpp('')

        setIsFinished(true)
      }

      isClient() &&
        window.location.assign(
          'https://whatsapp.escale.com.br/itau-consig-ben-bloq'
        )
    } finally {
      setIsLoading(false)
    }
  }

  return {
    isAlertVisible,
    carouselConfig,
    closeAlert,
    handleHelpBtn,
    handleInssBtn,
    isLoading
  }
}
